module.exports = __webpack_public_path__ + "media/images/icon_account_status_complete-741eeb93b287498f2f8baaae1b1540ab.svg";